import { render, staticRenderFns } from "./edit_table.vue?vue&type=template&id=57db60c8&scoped=true&"
import script from "./edit_table.vue?vue&type=script&lang=js&"
export * from "./edit_table.vue?vue&type=script&lang=js&"
import style0 from "./edit_table.vue?vue&type=style&index=0&id=57db60c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57db60c8",
  null
  
)

export default component.exports